import React from "react";

import "./index.scss";

const ScatterPlotIcon = ({ isActive }) => {
  const style = isActive ? "plot-icon--active" : "";
  return (
    <svg
      id="Scatter_Plot"
      data-name="Scatter Plot"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      className={`scatter-plot-icon--container ${style}`}
    >
      <path id="margin" d="M0,0H32V32H0Z" fill="none" />
      <path
        id="Path_15851"
        data-name="Path 15851"
        className="scatter-icon"
        d="M22.154,11.385a1.848,1.848,0,0,0-1.846,1.846,1.824,1.824,0,0,0,.238.889l-2.108,2.845a1.781,1.781,0,0,0-1.216.164l-1.462-1.1a1.825,1.825,0,0,0,.034-.341,1.846,1.846,0,0,0-3.692,0,1.825,1.825,0,0,0,.035.341l-1.462,1.1a1.823,1.823,0,0,0-.829-.206,1.853,1.853,0,1,0,1.687,1.1l1.234-.926a1.809,1.809,0,0,0,2.363,0l1.235.926a1.848,1.848,0,1,0,3.12-.4l1.983-2.678a1.845,1.845,0,1,0,.686-3.557Zm-12.308,8a.616.616,0,1,1,.616-.616A.617.617,0,0,1,9.846,19.385Zm4.1-3.077a.616.616,0,1,1,.616-.616A.616.616,0,0,1,13.948,16.308Zm4.1,3.077a.616.616,0,1,1,.615-.616A.618.618,0,0,1,18.052,19.385Zm4.1-5.539a.616.616,0,1,1,.615-.615A.617.617,0,0,1,22.154,13.846Z"
        fill="#969696"
      />
    </svg>
  );
};

export default ScatterPlotIcon;
